export default "__VITE_ASSET__DfzokJ$j__"